import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetSupportCountQuery } from 'src/store/Reducer/users';
import {
  initializeSupportCounts,
  selectSupportCounts,
  setSupportCounts,
} from 'src/redux/supportCountsSlice';
import { connectSocket } from 'src/utils/socket';

/**
 * Returns real-time Contact Support and Contact Us counts.
 *
 * - Fetches initial counts via RTK Query exactly once per session.
 * - Keeps counts in Redux so route changes do not trigger a refetch.
 * - Pass `skip: true` to disable both the query and socket subscription.
 *
 * @param {{ skip?: boolean }} options
 * @returns {{ supportCount: number, contactUsCount: number }}
 */
export function useSupportCounts({ skip = false } = {}) {
  const dispatch = useDispatch();
  const { supportCount, contactUsCount, initialized } = useSelector(selectSupportCounts);

  const { data } = useGetSupportCountQuery(undefined, {
    skip: skip || initialized,
  });

  useEffect(() => {
    if (!data || initialized) return;

    dispatch(
      initializeSupportCounts({
        supportCount: data?.supportCount ?? 0,
        contactUsCount: data?.contactUsCount ?? 0,
      })
    );
  }, [data, dispatch, initialized]);

  useEffect(() => {
    if (skip) return undefined;
    const socket = connectSocket();


    const handleCounts = ({ supportCount: nextSupportCount, contactUsCount: nextContactUsCount }) => {
      dispatch(
        setSupportCounts({
          supportCount: nextSupportCount,
          contactUsCount: nextContactUsCount,
        })
      );
    };


    return () => {
    };
  }, [dispatch, skip]);

  return { supportCount, contactUsCount };
}
